import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/Form';
import Select from '@/components/ui/Select/Select';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const CAR_CONDITION = {
  REPAIRED: 'repaired',
  GOING_TO_BE_REPAIRED: 'going_to_be_repaired',
  SOLD_REPAIRED: 'sold_repaired',
  SOLD_DAMAGED: 'sold_damaged',
  GOING_TO_BE_SOLD_DAMAGED: 'going_to_be_sold_damaged',
} as const;

export const CAR_CONDITION_NAME = 'car_condition';
export const CAR_CONDITION_NAME_COMPLEMENTARY = 'car_condition_complementary';

interface Props {
  name?: string;
  isComplementary?: boolean;
}

export const SelectCarCondition: FC<Props> = ({
  name,
  isComplementary = false,
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  const fieldName =
    name ??
    (isComplementary ? CAR_CONDITION_NAME_COMPLEMENTARY : CAR_CONDITION_NAME);

  return (
    <FormField
      control={control}
      name={fieldName}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field, fieldState }) => (
        <FormItem>
          <FormLabel>
            {i18n.t('W jakim stanie aktualnie jest samochód?')}
          </FormLabel>
          <FormControl>
            <Select
              {...field}
              placeholder={i18n.t('Aktualny stan samochodu')}
              success={!fieldState.error && field.value}
              options={[
                {
                  label: i18n.t('Został naprawiony'),
                  value: CAR_CONDITION.REPAIRED,
                },
                {
                  label: i18n.t('Zamierzam naprawić'),
                  value: CAR_CONDITION.GOING_TO_BE_REPAIRED,
                },
                {
                  label: i18n.t('Został sprzedany naprawiony'),
                  value: CAR_CONDITION.SOLD_REPAIRED,
                },
                {
                  label: i18n.t('Został sprzedany uszkodzony'),
                  value: CAR_CONDITION.SOLD_DAMAGED,
                },
                {
                  label: i18n.t('Zamierzam sprzedać uszkodzony'),
                  value: CAR_CONDITION.GOING_TO_BE_SOLD_DAMAGED,
                },
              ]}
              data-testid="multi-select-car-condition"
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
